export const DASHBOARD_API_ROUTES = {
    DASHBOARD: 'dashboard/userTestDetails',
    TESTRESULT: 'dashboard/testResult',
    TESTREVIEW: 'dashboard/testReview',
    LEADERBOARD: 'dashboard/leaderBoard',
    TEST_SERIES_RESULT: 'dashboard/testExamResult',
    TEST_SERIES_REVIEW: 'dashboard/testReview',
    LEADERBOARD_TEST_SERIES: 'dashboard/leaderExamBoard',
    DASHBOARD_TEST_SERIES: "dashboard/userTestExamDetails",
    POPULAR_TEST: 'testPage/popularTest',
    ADVICORY_TEST_SERIES: 'testPage/getadviceoryTestSeries',
    // AVG_DURATIONS:"dashboard/UserActivityhours"
    AVG_DURATIONS: "dashboard/UserActivityhoursBysubject",
    EXAM_DETAILS: 'testPage/examDetails',
    TEST_DETAILS: 'testPage/testDetails',
    BALANCE_TESTS: 'dashboard/getexambalance',
    USER_FEEDBACK: 'dashboard/userTestFeedback',
    GET_FEEDBACK: 'dashboard/getuserTestFeedback',
    GET_ERROR_LIST_DROPDOWN: '/questionerrorreport/question-error-list',
    SUBMIT_REPORT: '/questionerrorreport/question-error'



}